// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dropship controls — avoid global theme \`.btn\` (huge padding + transition:all). */

.dropship-embedded {
  max-width: none;
}

.dropship-tabs,
.dropship-chips,
.dropship-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.dropship-tab,
.dropship-chip,
.dropship-action {
  box-sizing: border-box;
  flex: 0 0 auto;
  width: auto !important;
  max-width: none;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 1.25;
  padding: 0.4rem 0.85rem;
  text-transform: none;
  text-decoration: none;
  white-space: nowrap;
  border-radius: 4px;
  border: 1px solid #212529;
  background: #fff;
  color: #212529;
  cursor: pointer;
  transition: none !important;
  box-shadow: none !important;
  appearance: none;
}

.dropship-chip {
  font-size: 0.8125rem;
  padding: 0.3rem 0.7rem;
  border-color: #6c757d;
  color: #343a40;
}

.dropship-tab.is-active,
.dropship-chip.is-active,
.dropship-action.is-active {
  background: #212529;
  border-color: #212529;
  color: #fff;
}

.dropship-chip.is-empty:not(.is-active) {
  opacity: 0.45;
  border-style: dashed;
}

.dropship-action {
  font-size: 0.8125rem;
  padding: 0.35rem 0.75rem;
}

.dropship-action-primary {
  background: #212529;
  border-color: #212529;
  color: #fff;
}

.card {
  border: 1px solid #e5e5e5;
}

.catalog-card {
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background: #fff;
  padding: 0.5rem;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: normal;
  text-transform: none;
  line-height: 1.3;
  width: 100%;
  text-align: left;
  color: inherit;
  transition: none !important;
  box-shadow: none !important;
}

.catalog-card:hover {
  border-color: #333;
}

.catalog-thumb {
  width: 100%;
  aspect-ratio: 1;
  background: #f3f3f3 center/cover no-repeat;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.catalog-title {
  font-size: 0.9rem;
  line-height: 1.3;
  max-height: 2.6em;
  overflow: hidden;
  margin-bottom: 0.25rem;
}

.catalog-detail {
  border-top: 1px solid #e5e5e5;
  padding-top: 1rem;
}

.catalog-grid {
  min-height: 4rem;
}

.catalog-grid.is-loading {
  opacity: 0.45;
  pointer-events: none;
}

.catalog-hero {
  width: 100%;
  max-height: 420px;
  object-fit: contain;
  background: #f8f9fa;
}

.catalog-thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.catalog-thumb-btn {
  width: 52px;
  height: 52px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #f3f3f3 center/cover no-repeat;
  padding: 0;
  cursor: pointer;
}

.catalog-thumb-btn.is-active {
  border-color: #212529;
  box-shadow: 0 0 0 1px #212529;
}

.catalog-option-chip {
  gap: 0.35rem;
}

.catalog-swatch {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #eee center/cover no-repeat;
  flex: 0 0 auto;
}

.catalog-row-thumb {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #dee2e6;
  background: #f3f3f3 center/cover no-repeat;
}

.catalog-description-body {
  max-height: 320px;
  overflow: auto;
  font-size: 0.875rem;
  line-height: 1.45;
  background: #fff;
  position: relative;
  z-index: 0;
  isolation: isolate;
}

.catalog-description-body ::ng-deep img {
  max-width: 100%;
  height: auto;
}

.catalog-description-body ::ng-deep a,
.catalog-description-body ::ng-deep button {
  pointer-events: none;
}

.catalog-import-panel {
  background: #f8f9fa;
}

.catalog-import-panel .form-label {
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/app/dropship/dropship.component.css"],"names":[],"mappings":"AAAA,mFAAmF;;AAEnF;EACE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAE3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Dropship controls — avoid global theme `.btn` (huge padding + transition:all). */\n\n.dropship-embedded {\n  max-width: none;\n}\n\n.dropship-tabs,\n.dropship-chips,\n.dropship-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.dropship-tab,\n.dropship-chip,\n.dropship-action {\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  width: auto !important;\n  max-width: none;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: normal;\n  line-height: 1.25;\n  padding: 0.4rem 0.85rem;\n  text-transform: none;\n  text-decoration: none;\n  white-space: nowrap;\n  border-radius: 4px;\n  border: 1px solid #212529;\n  background: #fff;\n  color: #212529;\n  cursor: pointer;\n  transition: none !important;\n  box-shadow: none !important;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.dropship-chip {\n  font-size: 0.8125rem;\n  padding: 0.3rem 0.7rem;\n  border-color: #6c757d;\n  color: #343a40;\n}\n\n.dropship-tab.is-active,\n.dropship-chip.is-active,\n.dropship-action.is-active {\n  background: #212529;\n  border-color: #212529;\n  color: #fff;\n}\n\n.dropship-chip.is-empty:not(.is-active) {\n  opacity: 0.45;\n  border-style: dashed;\n}\n\n.dropship-action {\n  font-size: 0.8125rem;\n  padding: 0.35rem 0.75rem;\n}\n\n.dropship-action-primary {\n  background: #212529;\n  border-color: #212529;\n  color: #fff;\n}\n\n.card {\n  border: 1px solid #e5e5e5;\n}\n\n.catalog-card {\n  box-sizing: border-box;\n  border: 1px solid #e5e5e5;\n  border-radius: 6px;\n  background: #fff;\n  padding: 0.5rem;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: normal;\n  text-transform: none;\n  line-height: 1.3;\n  width: 100%;\n  text-align: left;\n  color: inherit;\n  transition: none !important;\n  box-shadow: none !important;\n}\n\n.catalog-card:hover {\n  border-color: #333;\n}\n\n.catalog-thumb {\n  width: 100%;\n  aspect-ratio: 1;\n  background: #f3f3f3 center/cover no-repeat;\n  border-radius: 4px;\n  margin-bottom: 0.5rem;\n}\n\n.catalog-title {\n  font-size: 0.9rem;\n  line-height: 1.3;\n  max-height: 2.6em;\n  overflow: hidden;\n  margin-bottom: 0.25rem;\n}\n\n.catalog-detail {\n  border-top: 1px solid #e5e5e5;\n  padding-top: 1rem;\n}\n\n.catalog-grid {\n  min-height: 4rem;\n}\n\n.catalog-grid.is-loading {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.catalog-hero {\n  width: 100%;\n  max-height: 420px;\n  object-fit: contain;\n  background: #f8f9fa;\n}\n\n.catalog-thumbs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.catalog-thumb-btn {\n  width: 52px;\n  height: 52px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  background: #f3f3f3 center/cover no-repeat;\n  padding: 0;\n  cursor: pointer;\n}\n\n.catalog-thumb-btn.is-active {\n  border-color: #212529;\n  box-shadow: 0 0 0 1px #212529;\n}\n\n.catalog-option-chip {\n  gap: 0.35rem;\n}\n\n.catalog-swatch {\n  width: 16px;\n  height: 16px;\n  border-radius: 2px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  background: #eee center/cover no-repeat;\n  flex: 0 0 auto;\n}\n\n.catalog-row-thumb {\n  width: 32px;\n  height: 32px;\n  border-radius: 3px;\n  border: 1px solid #dee2e6;\n  background: #f3f3f3 center/cover no-repeat;\n}\n\n.catalog-description-body {\n  max-height: 320px;\n  overflow: auto;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  background: #fff;\n  position: relative;\n  z-index: 0;\n  isolation: isolate;\n}\n\n.catalog-description-body ::ng-deep img {\n  max-width: 100%;\n  height: auto;\n}\n\n.catalog-description-body ::ng-deep a,\n.catalog-description-body ::ng-deep button {\n  pointer-events: none;\n}\n\n.catalog-import-panel {\n  background: #f8f9fa;\n}\n\n.catalog-import-panel .form-label {\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
